import React, { useEffect } from 'react';
import '../../../styles/mainContents.css'
import { fetchInventory } from '../../../redux/actions/PostActions';

import { useDispatch, connect } from 'react-redux';

function AuthStatusUpdate(props) {

  const dispatch = useDispatch();

  const { authreducerState } = props;

  return (

    <div>
         
        <div>
        
          { authreducerState !== undefined &&
              Object.keys(authreducerState).length > 0 && 
              authreducerState.authStatusSuccessful !== undefined && authreducerState.authStatusSuccessful !== ''?
                <div className='authStatusUpdatesSuccess'>
                  {authreducerState.authStatusSuccessful}
                </div>              
            : ''
          }

        </div>

        
    </div>

  );
}



const mapStateToProps = (state) => {
  //console.log("AuthStatusUpdate() mapStateToProps state: " + JSON.stringify(state));

 return {
  authreducerState: state.authreducer
 }

};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_landingPageStates: (user) => {
      //dispatch(fetchInventory(user));
    },   
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthStatusUpdate);